import { FC, ReactNode, useEffect, useState, useCallback } from 'react'
import { Icon } from '@/client/components'
import { useScrollPosition } from '@/client/hooks'
import { IHeader, IFooter } from '@/client/types'
import { SEOProps } from '@/client/types'
import Head from './Head'
import * as S from './styles'
import Footer from '../Footer'
import Header from '../Header'
import SideBarMenu from '../SideBarMenu'

type PageProps = {
  seo?: SEOProps
  noIndex?: boolean
  children?: ReactNode
} & IHeader &
  IFooter

const Page: FC<PageProps> = ({ seo, children, header, footer, noIndex }) => {
  const [showButton, setShowButton] = useState<boolean>(false)
  const [isSidebarOpen, setIsSideBarOpen] = useState<boolean>(false)

  const offset = useScrollPosition()

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // for smoothly scrolling
    })
  }, [])

  useEffect(() => {
    if (offset > 1000) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }, [offset])

  return (
    <>
      {seo && <Head seo={seo} noIndex={noIndex} />}
      <Header header={header} setIsSideBarOpen={setIsSideBarOpen} isSidebarOpen={isSidebarOpen} />
      <main id='main'>{children}</main>
      <Footer footer={footer} />
      {showButton && (
        <S.BackToTop onClick={scrollToTop}>
          <Icon name='arrow-top' size='s5' />
        </S.BackToTop>
      )}
      <SideBarMenu
        options={header.menu_navigation}
        commercialLinks={footer.bottom_footer.footer_links}
        socialLinks={footer.bottom_footer.left_side}
        setIsSideBarOpen={setIsSideBarOpen}
        isSidebarOpen={isSidebarOpen}
      />
    </>
  )
}

export default Page
